export default "__VITE_ASSET__CH$zjudz__"